module.exports = __webpack_public_path__ + "static/media/next-icon-add-otoshi-o.3652baf6.svg";